import React, { useState } from 'react'
import './SupplyItem.css'

function SupplyItem(props) {
    let item = props.item;
    const [qty, setQty] = useState(item.qtyApproved>=0 ? item.qtyApproved : item.qtyOrdered);
    const [notes, setNotes] = useState(item.notes);
    function onQtyChange(value) {
        if (value.target.value < 0) {
            setQty(qty);
            return;
        }
        props.setQuantity(Number(value.target.value));
        setQty(value.target.value);
    }
    function onNotesChange(value) {
        props.setNotes(value.target.value);
        setNotes(value.target.value);
    }
    return (
        <>
            <td className="tooltip-container col-4">
                <div>
                    {item.name}
                    <span className="tooltip-text">{item.description}</span>
                </div>
            </td>

            {(props.hasEditPermission && props.ostatus === "Incomplete") && (
                <>
                    <td className='col-1'>{item.qtyRecommended}</td>
                    <td className='col-1'>{item.qtyOrdered}</td>
                    <td className='col-1'>{item.qtyAll}</td>

                    <td className='col-2'>
                        <input type="number" value={qty} className="form-control" id="qty" name='approvedQty' min={0}
                            onChange={onQtyChange} />
                    </td>
                    <td className='col-4'>
                        <input type="text" value={notes} className="form-control" id="notes" name='notes' maxLength={100}
                            onChange={onNotesChange} />
                    </td>
                </>
            )
            }
            {(!props.hasEditPermission) &&
                (<td className='col-1'>{item.qtyApproved >=0 ? item.qtyApproved : item.qtyOrdered}</td>)}

            {(props.hasEditPermission && props.ostatus !== "Incomplete") &&
                (
                    <>
                        <td className='col-1'>{item.qtyRecommended}</td>
                        <td className='col-1'>{item.qtyOrdered}</td>
                        <td className='col-1'>{item.qtyAll}</td>
                        <td className='col-2'>{item.qtyApproved}</td>
                        <td className='col-4'>{item.notes}</td>
                    </>
                )
            }

        </>
    )
}

export default SupplyItem